import { render } from "./Activate.vue?vue&type=template&id=57be9131&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=ts"
export * from "./Activate.vue?vue&type=script&lang=ts"

import "./Activate.vue?vue&type=style&index=0&id=57be9131&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-57be9131"

export default script